export const ready = (callback) => {
  document.addEventListener("turbo:load", callback)

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => {
      if (!window.Turbo) callback()
    })
  } else {
    callback()
  }
}

export function initToasts() {
  document.querySelectorAll("[data-toast-message]").forEach((toast) => {
    bindToast(toast)
  })
}

export function initPasswordToggles() {
  document.querySelectorAll("[data-password-field]").forEach((field) => {
    if (field.dataset.passwordToggleBound === "true") return

    field.dataset.passwordToggleBound = "true"
    const input = field.querySelector("input")
    const button = field.querySelector("[data-password-toggle]")
    const icon = button?.querySelector(".bi")
    if (!input || !button) return

    input.type = "password"
    button.setAttribute("aria-label", "パスワードを表示する")
    icon?.classList.add("bi-eye")
    icon?.classList.remove("bi-eye-slash")

    button.addEventListener("click", () => {
      const showing = input.type === "text"
      input.type = showing ? "password" : "text"
      button.setAttribute("aria-label", showing ? "パスワードを表示する" : "パスワードを隠す")
      icon?.classList.toggle("bi-eye", showing)
      icon?.classList.toggle("bi-eye-slash", !showing)
    })
  })
}

export function showToast(message, type = "notice") {
  const container = document.querySelector("[data-toast-container]") || createToastContainer()
  const toast = document.createElement("div")
  toast.className = `flash toast-msg ${type}`
  toast.dataset.toastMessage = ""
  toast.innerHTML = `<span></span><button type="button" class="toast-close" data-toast-close aria-label="閉じる">×</button>`
  toast.querySelector("span").textContent = message
  container.appendChild(toast)
  bindToast(toast)
}

function bindToast(toast) {
  if (toast.dataset.toastBound === "true") return

  toast.dataset.toastBound = "true"
  const close = () => {
    toast.classList.add("hiding")
    window.setTimeout(() => toast.remove(), 260)
  }

  toast.querySelector("[data-toast-close]")?.addEventListener("click", close)
  window.setTimeout(close, 3600)
}

function createToastContainer() {
  const container = document.createElement("div")
  container.className = "toast-wrap"
  container.dataset.toastContainer = ""
  document.body.appendChild(container)
  return container
}
